import React from 'react'

export function isSpecialKeyPressed(
	event: React.MouseEvent | React.KeyboardEvent,
) {
	return event.ctrlKey || event.metaKey || event.altKey || event.shiftKey
}
